import React, { useMemo, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { svgSprite } from '../../../../../hybrid/wrappers';
import MenuOfficeItem from '../MenuOfficeItem/MenuOfficeItem';
import UserContext, { UserProfileContext } from '../../../../../common/utils/getContext';
import { generateActives, getItemMenu } from '../../../helpers';
import { useRouter } from 'next/router';
import RegionAndCurrencySwitcher from '../../../../regionAndCurrencySwitcher/RegionAndCurrencySwitcher/RegionAndCurrencySwitcher';
import { useUnscrollableBody } from '../../../../../common/utils/windowDimensions';
import MobMenu from '../../../../../hybrid/library/MobMenu/MobMenu';
import css from './MenuOffice.module.scss';
import classnames from 'classnames';
import { addedMenuItems } from '../../../../../common/utils/utils';

const MenuOffice = ({ mainMenu, toggleMenu, active }) => {
    const { roles = [], profileData } = useContext(UserProfileContext) || {};

    const [submenu, setSubmenu] = useState(false);
    const { lang, menu } = useContext(UserContext);
    const newOfficeItems = useMemo(() => addedMenuItems(profileData), [profileData]);
    const officeMenu = useMemo(
        () => [...(menu?.office || []), ...(newOfficeItems?.office || [])],
        [menu?.office, newOfficeItems]
    );

    const itemMenu = useMemo(
        () => getItemMenu(officeMenu, roles, lang, true, profileData, true),
        [roles, officeMenu, lang, profileData]
    );
    const router = useRouter();
    const activeItems = useMemo(() => generateActives(itemMenu, router, active), [itemMenu, router, active]);
    useUnscrollableBody(mainMenu, 'MenuOffice');

    return (
        <>
            <MobMenu expanded={mainMenu} removeMenu={() => toggleMenu()} compStyles={css}>
                <div onClick={() => toggleMenu()} className={css.officeMenuTitle}>
                    <div className={classnames('circleButton', css.officeMenuClose)}>
                        {svgSprite('cross', {
                            width: '20px',
                            height: '20px'
                        })}
                    </div>
                    {/* <p className={css.officeMenuTitleP}>
                        <T textName='menu' defaultStr='Меню' page='/office' />
                    </p> */}
                    <div>
                        <RegionAndCurrencySwitcher compStyle={{ wrapper: css.officeMenuTitleSwitcher }} />
                    </div>
                </div>
                <div className={classnames('scrollbar-hidden', css.officeMenuScroll)}>
                    <div className={css.officeMenuWrapper}>
                        {itemMenu
                            ? itemMenu.map((menuItem, idx) => (
                                  <MenuOfficeItem
                                      toggleMenu={toggleMenu}
                                      menuItem={menuItem}
                                      submenu={submenu}
                                      active={activeItems}
                                      setSubmenu={setSubmenu}
                                      key={`menuItem_${idx}`}
                                      isLast={idx === itemMenu.length - 1}
                                  />
                              ))
                            : null}
                    </div>
                </div>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    {/* {windowDimensions <= 992 && <LangSwitcher single={false} />}
                    {windowDimensions > 767 && <RegionAndCurrencySwitcher />} */}
                </div>
                {/* <AppButtons /> */}
                {/* <div className={css.officeMenuFooter}>
                    <p className={css.officeMenuFooterText}>
                        <T
                            textName='copyright'
                            vars={{
                                year: currentYear,
                                company: project?.company
                            }}
                            defaultStr='Copyright © ${year} ${company}. All rights reserved'
                            page='all'
                        />
                    </p>
                    <p className={css.menuFooterText}>
                        <T textName='devText' defaultStr='Разработка' page='all' />
                        {' — '}
                        <A className={css.cursorPointer} href={project?.developer?.link}>
                            {project?.developer?.text}
                        </A>
                    </p>
                </div> */}
            </MobMenu>
        </>
    );
};
MenuOffice.propTypes = {
    mainMenu: PropTypes.bool,
    toggleMenu: PropTypes.func,
    submenu: PropTypes.object,
    active: PropTypes.string,
    setSubmenu: PropTypes.func
};
export default MenuOffice;
